import Vue from 'vue'
import App from './App.vue'
import router from './router'
import i18n from '@/vendors/i18n'
import '@/components/index.js' // 组件

Vue.config.productionTip = false

// -------- mixin（begin） --------
import globalMixIn from '@/mixins/global'
Vue.mixin(globalMixIn)

// -------- important dayjs -----
// 可用 this.$dayjs() 使用
const dayjs = require('dayjs')

// Duration 增加了 .duration .isDuring API 来支持时间长度。
const duration = require('dayjs/plugin/duration')
dayjs.extend(duration)

// CustomParseFormat 拓展了 dayjs() 支持自定义时间格式. 参考：https://day.js.org/docs/zh-CN/plugin/custom-parse-format
const customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)
Vue.prototype.$dayjs = dayjs

// 自定义图标
import '@/assets/fonts/iconfont.css'

let app = new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')

window.app = app
window.app.bus = new Vue() // 创建一条基于 App 的总线给全局使用
